import { render } from "./OrderDataUpdateDateDisplay.vue?vue&type=template&id=e227e0b2"
import script from "./OrderDataUpdateDateDisplay.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderDataUpdateDateDisplay.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/codebuild/output/src3003388635/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/portal-dev-frontend/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/components/parts/OrderDataUpdateDateDisplay.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e227e0b2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e227e0b2', __exports__)) {
    console.log('reload')
    api.reload('e227e0b2', __exports__)
  }
  
  module.hot.accept("./OrderDataUpdateDateDisplay.vue?vue&type=template&id=e227e0b2", () => {
    console.log('re-render')
    api.rerender('e227e0b2', render)
  })

}


export default __exports__